<template>
    <div class="users-details">
        <div class="full-container">
            <div class="top-navbar">
                <div class="row align-items-center">
                    <div class="col-md-4">
                        <div class="top-navbar-left">
                            <div class="btn-back" @click="$router.push({ name: 'usersSummary' });">
                                <font-awesome-icon :icon="['fas', 'angle-left']" />
                                Back
                            </div>
                        </div>
                    </div> 
                    
                    <div class="col-md-4">
                        <div class="top-navbar-center">
                            User Details
                        </div>
                    </div>    

                    <div class="col-md-4">
                        <div class="top-navbar-right">
                            <button v-if="canCreate" class="btn btn-ecdc btn-shadow" @click="$router.push({ name: 'userCreate' });">Create User</button>
                            <!-- <button class="btn btn-ecdc btn-shadow ml-3">Export Report</button> -->
                        </div>
                    </div>                       
                </div>
            </div>

            <hr />

            <div class="row">
                <transition name="fade" mode="out-in">
                    <div v-show="toggleFilter" id="side-filter-col" class="col-lg-3">
                        <div class="side-filter">

                            <div class="title">
                                Filter
                            </div>

                            <div class="form-group">
                                <div class="label">Division</div>

                                <div>
                                    <div class="custom-control-inline pill-radio">
                                        <input id="north" type="checkbox" name="division" value="0" required class="custom-control-input" v-model="filter.division" @change="onChangeDivision()">
                                        <label class="" for="north">East</label>
                                    </div>
                                    <div class="custom-control-inline pill-radio">
                                        <input id="south" type="checkbox" name="division" value="1" required class="custom-control-input" v-model="filter.division" @change="onChangeDivision()">
                                        <label class="" for="south">West</label>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="label">Region</div>
                                <app-multi-select 
                                    :options="regionOptions.map(regionOption => regionOption.id)"
                                    :custom-label="opt => regionOptions.find(x => x.id == opt).name"
                                    :multiple="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="true" 
                                    :preselect-first="false"
                                    :placeholder="'-- All Region --'"
                                    v-model="filter.region"
                                    @input="onChangeRegion">
                                        <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
                                </app-multi-select>

                                <div class="selected-label" v-if="filter.region.length > 0">
                                    FILTER:
                                    <div v-for="region in filter.region" :key="region">{{ regionOptions.find(x => x.id == region).name}}</div>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="label">Area</div>
                                <div class="custom-modal-select" :class="{ 'selected': filter.area.length > 0 }" v-b-modal.area-modal>
                                    <input type="button" class="form-control" :value="filter.area.length > 0 ? filter.area.length + ' selected' : '-- All Area --'">
                                </div>

                                <div class="selected-label" v-if="filter.area.length > 0">
                                    FILTER:
                                    <div v-for="area in filter.area" :key="area">{{ areaOptions.find(x => x.id == area).name}}</div>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="label">Position</div>
                                <app-multi-select 
                                    :options="positionOptions.map(positionOption => positionOption.id)"
                                    :custom-label="opt => positionOptions.find(x => x.id == opt).name"
                                    :multiple="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="true" 
                                    :preselect-first="false"
                                    :placeholder="'-- All Position --'"
                                    v-model="filter.position">
                                        <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
                                </app-multi-select>

                                <div class="selected-label" v-if="filter.position.length > 0">
                                    FILTER:
                                    <div v-for="position in filter.position" :key="position">{{ positionOptions.find(x => x.id == position).name}}</div>
                                </div>
                            </div>

                            <div class="filter-action">
                                <button type="button" class="btn btn-ecdc btn-block" @click="setFilter()">Apply</button>
                                <button type="button" class="btn btn-link btn-block text-light" @click="clearFilter()">Clear Filter</button>
                            </div>
                        </div>
                    </div>
                </transition>

                <div id="table-content-col" :class="toggleFilter ? 'col-lg-9 filter-expanded' : 'col-lg'">

                    <div class="table-options row justify-content-between align-items-center">
                        <div class="col-sm">
                            <button @click='toggleFilter = !toggleFilter' type="button" class="btn btn-ecdc btn-filter">Filter</button>

                            <!-- <div class="table-search form-inline d-inline-block ml-4">
                                <input type="text" class="form-control" placeholder="Search by keyword">                         <button type="button" class="btn btn-ecdc btn-circle">
                                    <app-icon-search></app-icon-search>
                                </button>       
                            </div> -->
                        </div>
                        <div class="col-sm mt-3 mt-sm-0">
                            <app-paginate
                                :page-count="totalPage"
                                :click-handler="pagination"
                                :prev-text="'&laquo;'"
                                :next-text="'&raquo;'"
                                ref="paginateTop"
                                :container-class="'pagination justify-content-end'">
                            </app-paginate>
                        </div>
                    </div>

                    

                    <div class="table-responsive">
                        <table class="table table-hover table-striped result-table">
                            <thead>
                                <tr>
                                    <th>STAFF ID</th>
                                    <th>NAME</th>
                                    <th>GENDER</th>
                                    <th>POSITION</th>
                                    <th>IC No.</th>
                                    <th>DIVISION</th>
                                    <th>REGION</th>
                                    <th>AREA</th>
                                    <th>EMPLOYMENT STATUS</th>
                                    <th>USER TYPE</th>
                                    <th class="text-center" v-if="canEdit">ACTION</th>
                                </tr>
                            </thead>

                            <tbody v-if="!isLoading">
                                <tr v-for="user in usersData.result" v-bind:key="user.id">
                                    <td class="case-ignore">{{user.staff_id}}</td>
                                    <td>{{user.name}}</td>
                                    <td>{{user.gender}}</td>
                                    <td>{{user.position}}</td>
                                    <td>{{user.nric != "" ? user.nric : "-"}}</td>
                                    <td>{{user.division}}</td>
                                    <td>{{user.region}}</td>
                                    <td>{{user.area}}</td>
                                    <td>{{user.employment_status}}</td>
                                    <td>{{user.user_type}}</td>
                                    <td v-if="canEdit" class="text-center" @click="view(user.id)">
                                        <button class="btn btn-link btn-icon icon-right">
                                            View 
                                            <font-awesome-icon class="icon" :icon="['fas', 'angle-right']" />
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="row justify-content-between align-items-center table-options">
                        <div class="col-lg col-6">
                            <select class="form-control custom-select" v-model="pageLimit" @change="pagination(1)">
                                <option value="15">15</option>
                                <option value="30">30</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                            per page
                        </div>
                        <div class="col-lg text-lg-center text-right col-6">
                            {{ showingResults }}
                        </div>
                        <div class="col-lg mt-lg-0 mt-3">
                            <app-paginate
                                :page-count="totalPage"
                                :click-handler="pagination"
                                :prev-text="'&laquo;'"
                                :next-text="'&raquo;'"
                                ref="paginateBottom"
                                :container-class="'pagination justify-content-end'">
                            </app-paginate>

                        </div>
                    </div>

                </div>
            </div>
        </div>

        <b-modal id="area-modal" hide-header hide-footer centered size="xl">
            <img src="../assets/img/icon-close.png" alt="icon-close" class="img-fluid modal-close" @click="$bvModal.hide('area-modal')" /> 

            <div class="selection-modal">
                <h4 class="title text-left mb-5">Area</h4>

                <div class="form-group">
                    <div class="row">
                        <div v-for="area in areaOptions" v-bind:key="area.id" class="col-4 col-xl-2">
                            <div class="custom-control custom-checkbox form-check-inline">
                                <input class="custom-control-input" type="checkbox" :id="'inlineCheckbox' + area.id" :value="area.id" v-model="filter.area">
                                <label class="custom-control-label" :for="'inlineCheckbox' + area.id">{{ area.name }}</label>
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <button type="button" class="btn btn-ecdc" @click="$bvModal.hide('area-modal')">Done</button>
                    <button type="button" class="btn btn-link text-muted" @click="clearArea()">Clear Selection</button>
                </div>
            </div>
        </b-modal>
        <app-loader v-show="isLoading"></app-loader>
    </div>
</template>

<script>
import { getUsers, getRegions, getAreas } from '../api'
import { checkPermission } from '../api'
import Loader from './Loader.vue'
import Paginate from 'vuejs-paginate'
// import IconSearch from '../svg/Search.vue'
import Multiselect from 'vue-multiselect'

export default {
    components: {
        appLoader: Loader,
        appPaginate: Paginate,
        // appIconSearch: IconSearch,
        appMultiSelect: Multiselect
    },
    data() {
        return {
            filter: {
                division: [],
                region: [],
                area: [],
                position: []
            },
            regions: [],
            regionOptions: [],
            areas: [],
            areaOptions: [],
            positionOptions: [
                { name: 'GENERAL MANAGER', id: 1 },
                { name: 'GENERAL AFFAIR MANAGER', id: 2 },
                { name: 'IT MANAGER', id: 3 },
                { name: 'OFFICE ADMIN', id: 4 },
                { name: 'RECEPTIONIST', id: 5 },
                { name: 'SECURITY OFFICER', id: 6 },
                { name: 'DRIVER', id: 7 },
                { name: 'OFFICE BOY', id: 8 },
                { name: 'BUSINESS UNIT DIRECTOR', id: 9 },
                { name: 'BUSINESS DEVELOPMENT MANAGER', id: 10 },
                { name: 'STRATEGIC PLANNER', id: 11 },
                { name: 'ACCOUNT DIRECTOR', id: 12 },
                { name: 'ACCOUNT MANAGER', id: 13 },
                { name: 'ACCOUNT EXECUTIVE', id: 14 },
                { name: 'CREATIVE DIRECTOR', id: 15 },
                { name: 'ART DIRECTOR', id: 16 },
                { name: 'DESIGNER', id: 17 },
                { name: 'OPERATIONAL DIRECTOR', id: 18 },
                { name: 'ACTIVATION DIRECTOR', id: 19 },
                { name: 'REGIONAL AREA ACTIVATION MANAGER', id: 20 },
                { name: 'AREA ACTIVATION MANAGER', id: 21 },
                { name: 'ACTIVATION SUPERVISOR', id: 22 },
                { name: 'ADMINISTRATION EXECUTIVE (ACTIVATION)', id: 23 },
                { name: 'LOGISTIC OFFICER (ACTIVATION)', id: 24 },
                { name: 'SENIOR DATA INPUT', id: 25 },
                { name: 'DATA INPUT EXCECUTIVE', id: 26 },
                { name: 'SENIOR CALL CENTER', id: 27 },
                { name: 'CALL CENTER EXECUTIVE', id: 28 },
                { name: 'BA COORDINATOR (ACTIVATION)', id: 29 },
                { name: 'MARCOMM SUPERVISOR', id: 30 },
                { name: 'PROJECT MANAGER', id: 31 },
                { name: 'SENIOR PROJECT EXECUTIVE', id: 32 },
                { name: 'PROJECT EXECUTIVE', id: 33 },
                { name: 'EVENT DIRECTOR', id: 34 },
                { name: 'EVENT MANAGER', id: 35 },
                { name: 'EVENT EXECUTIVE', id: 36 },
                { name: 'FINANCE MANAGER', id: 37 },
                { name: 'FINANCE EXECUTIVE', id: 38 },
                { name: 'ACCOUNTS', id: 39 },
                { name: 'HR/LEGAL MANAGER', id: 40 },
                { name: 'HR EXECUTIVE', id: 41 },
                { name: 'LEGAL EXECUTIVE', id: 42 },
                { name: 'TEAM LEADER', id: 44 },
                { name: 'BA', id: 45 },
                { name: 'ADMIN SOUTH', id: 46 },
                { name: 'ADMIN NORTH', id: 47 },
                { name: 'OPERATIONAL ADMIN', id: 48 },
                { name: 'CDC ADMIN', id: 49 },
                { name: 'CLIENT (BENTOEL)', id: 50 },
                { name: '3WSR', id: 51 },
                { name: 'ARCO', id: 52 },
                { name: 'ASMO', id: 53 },
                { name: 'SUPER ADMIN', id: 99 }
            ],
            usersData: "",
            isLoading: true,
            proj_id: "2",
            canCreate: false,
            canEdit: false,
            totalPage: 0,
            pageLimit: 15,
            showingResults: "",
            toggleFilter: true
        }
    },
    async mounted() {

        await this.getUsers(1);
        await this.getRegions();
        await this.getAreas();
        this.canEdit = await this.checkPermission('edit user');
        this.canCreate = await this.checkPermission('create user');
        this.isLoading = false;
    },
    methods: {
        async getUsers(pageNum) {

            try {
                
                const result = await getUsers(this.filter, pageNum, this.pageLimit);

                this.usersData = result.data.data;
                this.totalPage = this.usersData.total / this.pageLimit;

                if(this.totalPage % 1 != 0)
                    this.totalPage = parseInt(this.totalPage) + 1;
                else
                    this.totalPage = parseInt(this.totalPage);

                var startPage = 1;
                
                if(pageNum != 1)
                    startPage = (this.pageLimit * (pageNum - 1)) + 1;

                var endPage = pageNum * this.pageLimit;

                if(endPage >= this.usersData.total)
                    endPage = this.usersData.total;

                this.showingResults = "Showing " + startPage + " - " + endPage + " of " + this.usersData.total + " results";
            }
            catch(err) {
                alert(err.response.data.message);
            }
        },
        async pagination(pageNum) {

            this.isLoading = true;

            if(pageNum != 0)
                this.$refs.paginateTop.selected = this.$refs.paginateBottom.selected = pageNum;
            else
                pageNum = this.$refs.paginateBottom.selected;

            await this.getUsers(pageNum);

            this.isLoading = false;
        },
        async checkPermission(permission) {

            try {
                const result = await checkPermission({permission:permission});
                return result.data.data;
            }
            catch(err) {
                return false;
            }
        },
        view(id) {
            this.$router.push({ name: "userDetail" , params: { 'id': id }});
        },
        async getRegions() {

            try {
                const result = await getRegions();
                this.regions = result.data.data;
                this.regionOptions = this.regions;
            }
            catch(err) { 
                alert(err.response.data.message);
            }
        },
        async getAreas() {

            try {
                const result = await getAreas();
                this.areas = result.data.data;
                this.areaOptions = this.areas;
            }
            catch(err) {
                alert(err.response.data.message);
            }
        },
        onChangeDivision() {
            
            const _this = this;
            this.regionOptions = [];
            this.filter.region = [];
            this.areaOptions = this.areas;
            this.filter.area = [];

           if(this.filter.division.length > 0) {

                this.filter.division.forEach(division => {
                    const found = _this.regions.filter(value => value.division == division);

                    found.forEach(value => {
                        _this.regionOptions.push(value);
                    });
                });
            }
            else {

                this.regionOptions = this.regions;
            }
        },
        onChangeRegion() {
            
            const _this = this;
            this.areaOptions = [];
            this.filter.area = [];

            if(this.filter.region.length > 0) {

                this.filter.region.forEach(region => {

                    const found = _this.areas.filter(value => value.region_id == region);
                    
                    found.forEach(value => {
                        _this.areaOptions.push(value);
                    });
                });
            }
            else {

                this.areaOptions = this.areas;
            }
        },
        clearArea() {
            
            this.filter.area = [];
        },
        clearFilter() {
            
            this.filter.division = [];
            this.filter.region = [];
            this.filter.area = [];
            this.filter.position = [];

            this.regionOptions = this.regions;
            this.areaOptions = this.areas;
        },
        async setFilter() {

            this.isLoading = true;
            await this.getUsers(1);
            this.isLoading = false;
        }
    }
}
</script>